import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
var Event = /*#__PURE__*/_createClass(function Event() {
  var _this = this;
  _classCallCheck(this, Event);
  this.on = function (event, fn) {
    if (!event || 'function' !== typeof fn) throw 'eventName is null or handle is not a function, on fail';
    if (!_Array$isArray(_this.eventsHandle[event])) _this.eventsHandle[event] = [];
    _this.eventsHandle[event].push(fn);
  };
  this.off = function (event, fn) {
    if (!event) throw 'eventName is null, invoke off fail';
    if (!fn) {
      _this.eventsHandle[event] = [];
      return;
    }
    if (_Array$isArray(_this.eventsHandle[event])) {
      var _context, _context2;
      var n = _indexOfInstanceProperty(_context = _this.eventsHandle[event]).call(_context, fn);
      -1 !== n && _spliceInstanceProperty(_context2 = _this.eventsHandle[event]).call(_context2, n, 1);
    }
  };
  this.execEvent = function (event, data) {
    var _context3;
    _Array$isArray(this.eventsHandle[event]) && _forEachInstanceProperty(_context3 = this.eventsHandle[event]).call(_context3, function (fn) {
      try {
        fn(data);
      } catch (t) {
        console.error(data);
      }
    });
  };
  this.eventsHandle = {};
});
var event = new Event();
export default event;


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/helper/event.js
// module id = null
// module chunks = 